import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const AuthProtected = (props) => {
    const authCtx = useAuth();
    const { isAuthenticated } = authCtx;
    if (!isAuthenticated) {
        return (
            <Navigate to={{ pathname: "/login", state: { from: props.location } }} />
        );
    }

    return <>{props.children}</>;
}

export { AuthProtected };